import MinimalFooter from "@stadium/ui/src/components/footer";

import { VISIBLE_LINKS } from "@stadium/ui/src/components/footer/constants";
import { FOOTER_PROPS } from "@stadium/constants";

const Footer = () => {
  const footerProps = {
    ...FOOTER_PROPS,
    visibleLinks: VISIBLE_LINKS,
    leftNavEnabled: true,
  };

  return (
    <MinimalFooter {...footerProps} />
  );
};

export default Footer;
